/**
 * Occy Platform Design v4 chrome — the only place surface hex lives.
 * Light + dark theme objects, ThemeCssVars, and SCSS `var(--bs-*)` all read this.
 */
export const lightChrome = {
  header: '#0d2349',
  workspace: '#E7E7E7',
  workspaceRgb: '231, 231, 231',
  surface: '#FFFFFF',
  surfaceSubtle: '#F5F5F5',
  card: '#FFFFFF',
  fieldLabel: '#0d2349',
  onHeader: '#FFFFFF',
  radiusCard: '10px',
  radiusModal: '20px',
  dropZone: '#367ECA0F',
  // Light: navy title bar, workspace sheet; left tabs/content panel stays white.
  modal: '#E7E7E7',
  modalHeader: '#0d2349',
  modalPanel: '#FFFFFF',
};

export const darkChrome = {
  header: '#101924',
  workspace: '#1C252F',
  workspaceRgb: '28, 37, 47',
  surface: '#28303A',
  surfaceSubtle: '#1C252F',
  card: '#101924',
  fieldLabel: '#343B45',
  onHeader: '#FFFFFF',
  radiusCard: '10px',
  radiusModal: '20px',
  dropZone: '#101924CC',
  // Dark: header + modal frame #101924; left tabs/content panel #28303A.
  modal: '#101924',
  modalHeader: '#101924',
  modalPanel: '#28303A',
};
